import { render, staticRenderFns } from "./ConfidenceScore.vue?vue&type=template&id=2a348298&scoped=true"
import script from "./ConfidenceScore.vue?vue&type=script&lang=js"
export * from "./ConfidenceScore.vue?vue&type=script&lang=js"
import style0 from "./ConfidenceScore.vue?vue&type=style&index=0&id=2a348298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a348298",
  null
  
)

export default component.exports